import { Navigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import PendingApproval from './PendingApproval';

type ProtectedRouteProps = {
  children: React.ReactNode;
  adminOnly?: boolean;
};

export default function ProtectedRoute({ children, adminOnly = false }: ProtectedRouteProps) {
  const { user, profile, profileReady, loading } = useAuth();

  // El perfil llega después de la sesión: al recargar /admin, `profile` aún es null y el rol no se sabe. Se espera
  // a que la consulta termine en vez de mandar al chat (15-10); si falla, se sigue como antes (sin rol → /chat).
  if (loading || (adminOnly && user && !profile && profileReady === false)) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-gray-600">Cargando...</div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  // Closed signup gate. profile?.status is undefined pre-migration 116
  // (database/migrations/116_ADD_PROFILE_APPROVAL_STATUS.sql) — treat that
  // as approved and fall through to existing behavior.
  if (profile?.status === 'pending' || profile?.status === 'rejected') {
    return <PendingApproval status={profile.status} />;
  }

  if (adminOnly && profile?.role !== 'admin') {
    return <Navigate to="/chat" replace />;
  }

  return <>{children}</>;
}
